export const DEPOSIT_LIMIT_EXCEEDED_URL = "deposit-limit-calculator.image.deposit-limit-exceeded";
